// extracted by mini-css-extract-plugin
module.exports = {"section-title":"e5dfe","sectionTitle":"e5dfe","wrapper":"_6c769","items":"_45cf4","item":"_75bfd"};